/** angular */
import { NgModule } from '@angular/core';
/** end angular */

/** modules */
import { ChartsModule } from 'ng2-charts';
import { DsLibSharedModule } from '../../../shared/ds-lib-shared.module';
/** end modules */

/** components */
import { DsGenericChartComponent } from './components/ds-generic-chart/ds-generic-chart.component';
/** end components */

const components = [DsGenericChartComponent];

@NgModule({
  declarations: components,
  imports: [DsLibSharedModule, ChartsModule],
  exports: components,
  providers: [],
})
export class DsGenericChartModule {}
